var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2ChildRoomBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.39 25.47a10.51 10.51 0 00-20.31-3.82 20.538 20.538 0 00-7.81-.05 10.512 10.512 0 00-16.351-4.318 10.51 10.51 0 00.691 16.898 20.999 20.999 0 1038.85.19 10.51 10.51 0 004.93-8.9zM20.94 30a5.79 5.79 0 118.77-7 21.07 21.07 0 00-8.77 7zm6.67 3.32a3 3 0 013-3c.414-.002.824.087 1.2.26a3 3 0 11-4.2 2.77v-.03zM38 59a10 10 0 110-20 10 10 0 010 20zm10.74-24.94a3.001 3.001 0 11-4.42-3.28c.454-.28.977-.429 1.51-.43a3 3 0 013 3c0 .24-.03.478-.09.71zm6.45-3.85a21.06 21.06 0 00-8.6-7.11 5.789 5.789 0 0111.071 2.598 5.79 5.79 0 01-2.471 4.512zM42 46.94a4 4 0 11-8 0 4 4 0 018 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Child_room_bis.f9bb8bcc.svg";
export { SvgE2ChildRoomBis as ReactComponent };